import { render, staticRenderFns } from "./CompanyDeleteModal.vue?vue&type=template&id=2cbed943&"
import script from "./CompanyDeleteModal.vue?vue&type=script&lang=js&"
export * from "./CompanyDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports